module.exports = __webpack_public_path__ + "img/ford-logo.604d436b.svg";